var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import { ModuleLink, ModuleTitle, ModuleDescription, ModuleMetadata } from '../';
import { FormatMetric } from "../";
import { getUrlFromProps } from "../../resources/functions/";

var AnalyticsTableBodyRow = (_temp2 = _class = function (_Component) {
    _inherits(AnalyticsTableBodyRow, _Component);

    function AnalyticsTableBodyRow() {
        var _temp, _this, _ret;

        _classCallCheck(this, AnalyticsTableBodyRow);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getClassName = function () {
            return "admin-analytics-table__row";
        }, _this.renderDimensions = function () {
            var _this$props = _this.props,
                dimensions = _this$props.dimensions,
                thStyle = _this$props.thStyle,
                urlPattern = _this$props.urlPattern;


            var metadata = [];

            if (dimensions.length >= 2) {
                metadata = dimensions.slice(1, dimensions.length);
            }

            var url = getUrlFromProps(_this.props);

            if (url) {
                metadata.push(url);
            }

            return React.createElement(
                'th',
                { style: thStyle },
                React.createElement(
                    ModuleLink,
                    { url: url },
                    React.createElement(ModuleTitle, { title: dimensions[0] }),
                    React.createElement(ModuleMetadata, { metadata: metadata })
                )
            );
        }, _this.renderMetricValue = function (metric, index) {
            var _this$props2 = _this.props,
                metrics = _this$props2.metrics,
                totals = _this$props2.totals,
                sortBy = _this$props2.sortBy,
                tdStyle = _this$props2.tdStyle;
            var name = metric.name,
                type = metric.type;

            var value = metrics[0].values[index];

            var selected = void 0;

            if (sortBy === name) {
                selected = true;
            }

            var pctOfTotal = value / totals[index] * 100;

            return React.createElement(
                'td',
                { style: tdStyle, key: index, 'aria-selected': selected },
                React.createElement(
                    'b',
                    null,
                    React.createElement(FormatMetric, _extends({}, metric, { value: value }))
                ),
                React.createElement(
                    'i',
                    null,
                    React.createElement(FormatMetric, { type: 'PERCENT', value: pctOfTotal })
                )
            );
        }, _this.renderMetrics = function () {
            var metricHeaders = _this.props.metricHeaders;


            return metricHeaders.map(_this.renderMetricValue);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    AnalyticsTableBodyRow.prototype.render = function render() {
        var className = this.getClassName();

        return React.createElement(
            'tr',
            { className: className },
            this.renderDimensions(),
            this.renderMetrics()
        );
    };

    return AnalyticsTableBodyRow;
}(Component), _class.defaultProps = {
    dimensions: [],
    metrics: [],
    urlPattern: undefined
}, _temp2);


export default AnalyticsTableBodyRow;